export const alarmSeverityColors=['#7F7F7F','#53CBCB','#F9C46D','#EE7D60'];